import { connect } from 'react-redux';
import { compose } from 'recompose';

import { getForcedFieldValidationConfig } from './getForcedFieldValidationConfig';

/**
 * Enhances a component by a prop containing the validation feature config defined on the
 * Experimentation platform for a passed field name.
 * @param {string} fieldName Name of the field to retrieve the validation feature config for
 * @returns enhanced component with the `forcedValidationConfig` prop which contains an object that
 * maps the passed fieldName to its validation feature config (if it exists)
 */
export const withFeatureToggledValidation = fieldName =>
  compose(
    connect(state => {
      const forcedValidationConfig = getForcedFieldValidationConfig(fieldName)(state);
      if (forcedValidationConfig) {
        return {
          forcedValidationConfig: {
            [fieldName]: {
              ...forcedValidationConfig,
              validate: forcedValidationConfig.regex
                ? value => new RegExp(forcedValidationConfig.regex).test(value)
                : undefined,
            },
          },
        };
      }
    }),
  );
